<template>
  <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.75 15C1.75 15 0.5 15 0.5 13.75C0.5 12.5 1.75 8.75 8 8.75C14.25 8.75 15.5 12.5 15.5 13.75C15.5 15 14.25 15 14.25 15H1.75ZM8 7.5C8.99456 7.5 9.94839 7.10491 10.6517 6.40165C11.3549 5.69839 11.75 4.74456 11.75 3.75C11.75 2.75544 11.3549 1.80161 10.6517 1.09835C9.94839 0.395088 8.99456 0 8 0C7.00544 0 6.05161 0.395088 5.34835 1.09835C4.64509 1.80161 4.25 2.75544 4.25 3.75C4.25 4.74456 4.64509 5.69839 5.34835 6.40165C6.05161 7.10491 7.00544 7.5 8 7.5Z"
      fill="#F9E8C9" />
  </svg>
</template>
